<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import ThemedButton from '@/components/base/ThemedButton.vue';
import SimplifiedHeader from '@/components/layout/header/SimplifiedHeader.vue';
import { useAuth } from '@/composables/useAuth';
import { useCheckout } from '@/composables/useCheckout';
import { NutsRedirect } from '@/utils/exceptions';

const router = useRouter();
const store = useStore();
const { permissions } = useAuth(store);
const { cxMode, determineEntryLocation, prepareCartForCheckout, resetCheckout, toggleCXMode } =
  useCheckout(store);

const showToggleButton = computed(() => permissions.value.checkOutAsCustomer);
const buttonLoading = ref(false);

const toggleCheckoutMode = async () => {
  buttonLoading.value = true;
  toggleCXMode();
  await resetCheckout();
  await prepareCartForCheckout();
  const entryLocation = determineEntryLocation();
  if (!entryLocation) {
    throw new NutsRedirect('/cart');
  }
  buttonLoading.value = false;
  return router.push(entryLocation);
};
</script>

<template>
  <SimplifiedHeader logoLink="/cart" logoAlt="Go to cart page">
    <template #right>
      <div v-if="showToggleButton">
        <ThemedButton theme="white" :isLoading="buttonLoading" @click="toggleCheckoutMode">
          Go to {{ cxMode ? 'Customer' : 'CX' }} Checkout
        </ThemedButton>
      </div>
    </template>
  </SimplifiedHeader>
</template>
